const definitionsDe = {
  REVENUE_TODAY:
    'Nettoumsatz aus festgeschriebenen Rechnungen abzüglich Gutschriften und Stornos am gewählten Stichtag.',
  REVENUE_WEEK: 'Nettoumsatz vom Montag der Stichtagswoche bis zum gewählten Stichtag.',
  REVENUE_MONTH: 'Nettoumsatz vom Monatsersten bis zum gewählten Stichtag.',
  OPEN_QUOTES: 'Angebote, die weder abgelehnt noch abgeschlossen oder storniert sind.',
  OPEN_ORDERS: 'Aufträge, die weder abgeschlossen noch storniert sind.',
  DELIVERIES_TODAY: 'Lieferscheine mit Lieferdatum am gewählten Stichtag.',
  LATE_DELIVERIES:
    'Lieferscheine vor dem Stichtag, die noch nicht versendet, abgeschlossen oder storniert sind.',
  OPEN_INVOICES: 'Rechnungen mit offenem, teilbezahltem oder überfälligem Zahlungsstatus.',
  OVERDUE_RECEIVABLES:
    'Noch offener Bruttobetrag von Rechnungen, deren Fälligkeitsdatum überschritten ist.',
  NEW_CUSTOMERS: 'Im gewählten Zeitraum neu angelegte Kunden, die keine Interessenten sind.',
  NEW_LEADS: 'Im gewählten Zeitraum neu angelegte Geschäftspartner mit Interessentenrolle.',
  NEW_SUPPLIERS: 'Im gewählten Zeitraum neu angelegte Geschäftspartner mit Lieferantenrolle.',
  NEW_PRODUCTS: 'Im gewählten Zeitraum neu angelegte, nicht gelöschte Artikel.',
  LOW_INVENTORY: 'Aktive Lagerartikel auf oder unter Mindestbestand beziehungsweise Meldebestand.',
  OPEN_COMPLAINTS: 'Reklamationen im Status Offen oder In Bearbeitung.',
  DUE_SALES_TASKS: 'Nicht abgeschlossene Vertriebsaufgaben, die bis zum Stichtag fällig sind.',
  UPCOMING_CALLBACKS:
    'Offene Rückrufaufgaben vom Stichtag bis einschließlich der nächsten sieben Tage.',
};

export const dashboardDe = {
  subtitle: 'Ihr rollenbasierter Tagesüberblick aus aktuellen ERP-Daten.',
  generatedAt: 'Aktualisiert {{value}}',
  actions: {
    configure: 'Dashboard anpassen',
    retry: 'Erneut laden',
    definition: 'Kennzahl erklären',
    moveUp: 'Nach oben',
    moveDown: 'Nach unten',
  },
  filters: {
    period: 'Zeitraum',
    comparison: 'Vergleich',
    team: 'Team',
    employee: 'Mitarbeiter',
    location: 'Standort',
    territory: 'Vertriebsgebiet',
    all: 'Alle',
  },
  widgets: {
    REVENUE: 'Umsatz',
    DOCUMENTS: 'Belege und Forderungen',
    PARTNERS: 'Neue Stammdaten',
    INVENTORY: 'Lager',
    SALES_TASKS: 'Aufgaben und Reklamationen',
    ACTIVITY: 'Letzte Aktivitäten',
    PRODUCTS: 'Produkthighlights',
    TEAM: 'Vertriebs- und Teamübersicht',
  },
  kpis: {
    REVENUE_TODAY: 'Umsatz heute',
    REVENUE_WEEK: 'Umsatz diese Woche',
    REVENUE_MONTH: 'Umsatz dieser Monat',
    OPEN_QUOTES: 'Offene Angebote',
    OPEN_ORDERS: 'Offene Aufträge',
    DELIVERIES_TODAY: 'Heutige Lieferungen',
    LATE_DELIVERIES: 'Verspätete Lieferungen',
    OPEN_INVOICES: 'Offene Rechnungen',
    OVERDUE_RECEIVABLES: 'Überfällige Forderungen',
    NEW_CUSTOMERS: 'Neue Kunden',
    NEW_LEADS: 'Neue Interessenten',
    NEW_SUPPLIERS: 'Neue Lieferanten',
    NEW_PRODUCTS: 'Neue Artikel',
    LOW_INVENTORY: 'Niedrige Bestände',
    OPEN_COMPLAINTS: 'Offene Reklamationen',
    DUE_SALES_TASKS: 'Fällige Vertriebsaufgaben',
    UPCOMING_CALLBACKS: 'Anstehende Rückrufe',
  },
  definitions: definitionsDe,
  comparison: {
    previous: 'Vergleich: {{value}}',
    increased: '{{value}} % höher',
    decreased: '{{value}} % niedriger',
    noBasis: 'Keine belastbare Prozentbasis',
    snapshot: 'Aktueller Bestand; kein historischer Statusvergleich',
  },
  scope: {
    OWN: 'Eigene Daten',
    TEAM: 'Gefiltertes Team',
    ORGANIZATION: 'Berechtigter Organisationsumfang',
  },
  states: {
    widgetError: 'Dieser Dashboard-Bereich konnte nicht geladen werden.',
    noActivity: 'Im gewählten Zeitraum gibt es keine sichtbaren Aktivitäten.',
    allHidden:
      'Alle Bereiche sind ausgeblendet. Über „Dashboard anpassen“ können Sie Bereiche wieder einblenden.',
  },
  activity: {
    description: 'Fachereignisse und wichtige Änderungen, für die Sie leseberechtigt sind.',
    kinds: {
      CUSTOMER_CREATED: 'Kunde {{subject}} angelegt',
      LEAD_CREATED: 'Interessent {{subject}} angelegt',
      PRODUCT_CREATED: 'Artikel {{subject}} angelegt',
      PRODUCT_UPDATED: 'Artikel {{subject}} geändert',
      QUOTE_CREATED: 'Angebot für {{subject}} erstellt',
      ORDER_CREATED: 'Auftrag für {{subject}} erstellt',
      DELIVERY_SHIPPED: 'Lieferung für {{subject}} ausgelöst',
      INVOICE_SENT: 'Rechnung an {{subject}} versendet oder gebucht',
      PAYMENT_POSTED: 'Zahlung von {{subject}} verbucht',
      COMPLAINT_UPDATED: 'Reklamation „{{subject}}“ bearbeitet',
      TASK_COMPLETED: 'Aufgabe „{{subject}}“ erledigt',
      CONFIGURATION_CHANGED: 'Konfiguration {{subject}} geändert',
      USER_ACTION: 'Benutzer- oder Rollenaktion: {{subject}}',
    },
  },
  products: {
    description: 'Mehrfachnennungen sind möglich; jede Zeile erklärt einen fachlichen Hinweis.',
    highlight: 'Hinweis',
    product: 'Artikel',
    revenue: 'Umsatz',
    stock: 'Bestand',
    kinds: {
      TOP_SELLER: 'Meistverkauft',
      RISING_REVENUE: 'Umsatz steigt',
      NEW_PRODUCT: 'Neu',
      FALLING_DEMAND: 'Nachfrage sinkt',
      FREQUENT_STOCKOUT: 'Regelmäßig ausverkauft',
      CRITICAL_STOCK: 'Kritischer Bestand',
      NO_CURRENT_SALES: 'Kein aktueller Verkauf',
    },
  },
  team: {
    privacy:
      'Transparente Fachkennzahlen aus Aufgaben, Kontakten, Kunden und Belegen. Mitarbeiterdetails erscheinen nur mit ausdrücklichem Detailrecht.',
    person: 'Person/Umfang',
    aggregate: 'Freigegebenes Team (aggregiert)',
    due: 'Fällig',
    completed: 'Erledigt',
    contacts: 'Kontakte',
    customers: 'Neue Kunden',
    quotes: 'Angebote',
    orders: 'Aufträge',
    lastActivity: 'Letzte Aktivität',
  },
  configuration: {
    title: 'Persönliches Dashboard',
    description: 'Bereiche ein- oder ausblenden und ihre Reihenfolge festlegen.',
    error: 'Die persönliche Anordnung konnte nicht gespeichert werden.',
  },
};

export const dashboardEn = {
  ...dashboardDe,
  subtitle: 'Your role-based daily overview from current ERP data.',
  generatedAt: 'Updated {{value}}',
  actions: {
    configure: 'Customize dashboard',
    retry: 'Try again',
    definition: 'Explain metric',
    moveUp: 'Move up',
    moveDown: 'Move down',
  },
  filters: {
    period: 'Period',
    comparison: 'Comparison',
    team: 'Team',
    employee: 'Employee',
    location: 'Location',
    territory: 'Sales territory',
    all: 'All',
  },
  widgets: {
    REVENUE: 'Revenue',
    DOCUMENTS: 'Documents and receivables',
    PARTNERS: 'New master data',
    INVENTORY: 'Inventory',
    SALES_TASKS: 'Tasks and complaints',
    ACTIVITY: 'Recent activity',
    PRODUCTS: 'Product highlights',
    TEAM: 'Sales and team overview',
  },
  kpis: {
    REVENUE_TODAY: 'Revenue today',
    REVENUE_WEEK: 'Revenue this week',
    REVENUE_MONTH: 'Revenue this month',
    OPEN_QUOTES: 'Open quotes',
    OPEN_ORDERS: 'Open orders',
    DELIVERIES_TODAY: "Today's deliveries",
    LATE_DELIVERIES: 'Late deliveries',
    OPEN_INVOICES: 'Open invoices',
    OVERDUE_RECEIVABLES: 'Overdue receivables',
    NEW_CUSTOMERS: 'New customers',
    NEW_LEADS: 'New leads',
    NEW_SUPPLIERS: 'New suppliers',
    NEW_PRODUCTS: 'New products',
    LOW_INVENTORY: 'Low inventory',
    OPEN_COMPLAINTS: 'Open complaints',
    DUE_SALES_TASKS: 'Due sales tasks',
    UPCOMING_CALLBACKS: 'Upcoming callbacks',
  },
  comparison: {
    previous: 'Comparison: {{value}}',
    increased: '{{value}}% higher',
    decreased: '{{value}}% lower',
    noBasis: 'No reliable percentage basis',
    snapshot: 'Current backlog; no historical status comparison',
  },
  scope: { OWN: 'Own data', TEAM: 'Filtered team', ORGANIZATION: 'Authorized organization scope' },
  states: {
    widgetError: 'This dashboard section could not be loaded.',
    noActivity: 'There is no visible activity in this period.',
    allHidden: 'All sections are hidden. Use “Customize dashboard” to show them again.',
  },
  configuration: {
    title: 'Personal dashboard',
    description: 'Show or hide sections and set their order.',
    error: 'Your personal layout could not be saved.',
  },
};

export const dashboardFr = {
  ...dashboardEn,
  subtitle: 'Votre aperçu quotidien basé sur les rôles et les données ERP actuelles.',
  actions: {
    ...dashboardEn.actions,
    configure: 'Personnaliser le tableau de bord',
    retry: 'Réessayer',
  },
  filters: {
    ...dashboardEn.filters,
    period: 'Période',
    comparison: 'Comparaison',
    employee: 'Employé',
    location: 'Site',
    territory: 'Territoire commercial',
    all: 'Tous',
  },
};
export const dashboardEs = {
  ...dashboardEn,
  subtitle: 'Su resumen diario basado en roles y datos actuales del ERP.',
  actions: { ...dashboardEn.actions, configure: 'Personalizar panel', retry: 'Reintentar' },
  filters: {
    ...dashboardEn.filters,
    period: 'Periodo',
    comparison: 'Comparación',
    employee: 'Empleado',
    location: 'Ubicación',
    territory: 'Territorio de ventas',
    all: 'Todos',
  },
};
export const dashboardTr = {
  ...dashboardEn,
  subtitle: 'Güncel ERP verilerinden role dayalı günlük genel bakışınız.',
  actions: {
    ...dashboardEn.actions,
    configure: 'Gösterge panelini özelleştir',
    retry: 'Tekrar dene',
  },
  filters: {
    ...dashboardEn.filters,
    period: 'Dönem',
    comparison: 'Karşılaştırma',
    employee: 'Çalışan',
    location: 'Konum',
    territory: 'Satış bölgesi',
    all: 'Tümü',
  },
};
